// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/routes'

import axios from 'axios'
import store from './store/store'

// element import
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

// moment
Vue.use(require('vue-moment'))

// lodash
import VueLodash from 'vue-lodash'
const options = { name: 'lodash' } // customize the way you want to call it
Vue.use(VueLodash, options) // options is optional

// i18n
import i18n from './i18n'

Vue.config.productionTip = false

// global axios baseURL
axios.defaults.baseURL = process.env.VUE_APP_YIPPI_API_BASEURL
axios.defaults.headers.get['Accepts'] = 'application/json'

axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }
  config.headers['Accept-Language'] = localStorage.getItem('language')
  // console.log('Request Interceptor', config)
  return config
})
// axios.interceptors.request.eject(reqInterceptor)

// const resInterceptor = axios.interceptors.response.use(res => {
//   console.log( "Response Interceptor", res );
//   return res
// })
// axios.interceptors.response.eject(resInterceptor)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
